import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";

const extendedTablesStyle = {
  ...buttonStyle,
  ...customCheckboxRadioSwitch
};

export default extendedTablesStyle;
